import { Avatar, Divider, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

import PensieveLogo from '../images/PensieveLogo.png';
import NavigationCategories from '../common/NavigationCategories'

const Styles = {
    categoryHeader: {
        paddingTop: 1.25,
        paddingBottom: 1.25,
    },
    categoryHeaderPrimary: {
        fontSize: 'large',
        fontWeight: 'bold',
    },
    item: {
        marginTop: 1,
        paddingTop: 1,
        paddingBottom: 1,
        color: 'rgba(255, 255, 255, 0.7)',
        '&:hover,&:focus': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
        },
    },
    itemCategory: {
        marginTop: 0,
        backgroundColor: '#232f3e',
        boxShadow: '0 -1px 0 #404854 inset',
        paddingTop: 1,
        paddingBottom: 1,
    },
    pensieve: {
        marginTop: 0,
        backgroundColor: '#232f3e',
        boxShadow: '0 -1px 0 #404854 inset'
    },
    itemActiveItem: {
        color: '#5f43c7',
    },
    itemPrimary: {
        fontSize: 'inherit',
    },
    itemIcon: {
        minWidth: 'auto',
        marginRight: 2,
    },
    divider: {
        marginTop: 1,
        backgroundColor: '#404854',
    },
};

const HomePathLink = React.forwardRef<HTMLAnchorElement>((props, ref) => {
  return <Link to="/" ref={ref} {...props} />
});

const MenuBar = (props: any) => {
  const main = NavigationCategories[0];

  return (
      <Drawer variant='permanent' {...props}>
        <List disablePadding>
            <ListItem sx={Styles.pensieve} >
                <Avatar sx={{width:226, height:226}} variant='square' src={PensieveLogo} />
            </ListItem>
            <ListItem sx={[Styles.item, Styles.itemCategory]} component={HomePathLink} >
                <ListItemIcon sx={Styles.itemIcon}>
                    {main.icon}
                </ListItemIcon>
                <ListItemText primaryTypographyProps={{...Styles.itemPrimary, fontSize: 'large'}} >
                    {main.view!.title}
                </ListItemText>
            </ListItem>
            {NavigationCategories.filter(i => i.menu ).map(({id, children}) => (
                <React.Fragment key={id}>
                    <ListItem sx={[Styles.item, Styles.itemCategory, Styles.categoryHeader]}>
                        <ListItemText primaryTypographyProps={Styles.categoryHeaderPrimary} >
                            {id}
                        </ListItemText>
                    </ListItem>
                    {children.map(({id: childId, icon, path}) => (
                        <ListItemButton 
                          key={childId}
                          sx={[Styles.item]}
                          component={Link}
                          to={path}
                        >
                            <ListItemIcon sx={Styles.itemIcon}>{icon}</ListItemIcon>
                            <ListItemText primaryTypographyProps={Styles.itemPrimary}>
                                {childId}
                            </ListItemText>
                        </ListItemButton>
                    ))}
                    <Divider sx={Styles.divider} />
                </React.Fragment>
            ))}
        </List>
      </Drawer>
  )
}

export default MenuBar;